var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen"},[_c('CheckoutHeader'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }